import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Check, X } from "lucide-react";
import { reset_password } from "../../redux/actions/adminActions";

const Rule = ({ ok, label }) => (
  <span className={"auth__rule" + (ok ? " auth__rule--ok" : "")}>
    {ok ? <Check size={12} /> : <X size={12} />} {label}
  </span>
);

const Reset = () => {
  const [fields, setFields] = useState({ newPassword: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);
  const [passwordLength, setPasswordLength] = useState(false);
  const [passwordLower, setPasswordLower] = useState(false);
  const [passwordUpper, setPasswordUpper] = useState(false);
  const [passwordDigit, setPasswordDigit] = useState(false);
  const [passwordSpecial, setPasswordSpecial] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(false);

  const dispatch = useDispatch();
  const resetPassword = useSelector((state) => state.resetPassword);
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "newPassword") {
      setPasswordSpecial(/[!@#$%^&*]/.test(value));
      setPasswordLength(value.length >= 8 && value.length <= 15);
      setPasswordLower(/[a-z]/.test(value));
      setPasswordUpper(/[A-Z]/.test(value));
      setPasswordDigit(/[0-9]/.test(value));
      setPasswordMatch(value !== "" && value === fields.confirmPassword);
    }
    if (name === "confirmPassword") {
      setPasswordMatch(value !== "" && value === fields.newPassword);
    }
    setFields((f) => ({ ...f, [name]: value }));
  };

  const clear = () => setFields({ newPassword: "", confirmPassword: "" });

  const redirect = () => {
    if (location.state?.from) navigate(location.state.from);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!passwordLength || !passwordLower || !passwordUpper || !passwordDigit || !passwordSpecial || !passwordMatch) return;
    if (fields.newPassword && fields.confirmPassword) {
      dispatch(reset_password(params.token, fields.confirmPassword, redirect, clear));
    }
  };

  useEffect(() => {
    if (resetPassword) setLoading(resetPassword.loading);
  }, [resetPassword]);

  const allValid = passwordLength && passwordLower && passwordUpper && passwordDigit && passwordSpecial && passwordMatch;

  return (
    <form onSubmit={handleSubmit}>
      <p className="auth__pretitle">Roots Funding · Admin</p>
      <h1 className="auth__title">Reset password</h1>
      <p className="auth__sub">Choose a new password for your account</p>

      <div className="auth__field">
        <label className="auth__label" htmlFor="reset-new">New password</label>
        <input
          id="reset-new"
          type="password"
          name="newPassword"
          className="auth__input"
          placeholder="New password"
          value={fields.newPassword}
          onChange={handleChange}
          autoComplete="new-password"
        />
      </div>

      <div className="auth__field">
        <label className="auth__label" htmlFor="reset-confirm">Confirm password</label>
        <input
          id="reset-confirm"
          type="password"
          name="confirmPassword"
          className="auth__input"
          placeholder="Confirm password"
          value={fields.confirmPassword}
          onChange={handleChange}
          autoComplete="new-password"
        />
      </div>

      <div className="auth__rules">
        <Rule ok={passwordLength} label="8–15 characters" />
        <Rule ok={passwordUpper} label="At least one uppercase letter" />
        <Rule ok={passwordLower} label="At least one lowercase letter" />
        <Rule ok={passwordDigit} label="At least one number" />
        <Rule ok={passwordSpecial} label="At least one special character (!@#$%^&*)" />
        <Rule ok={passwordMatch} label="Passwords match" />
      </div>

      <button type="submit" className="auth__submit" disabled={loading || !allValid}>
        {loading ? "Updating…" : "Reset password"}
      </button>

      <Link to="/login" className="auth__link">Back to sign in</Link>
    </form>
  );
};

export default Reset;
